import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import request from '../ct-request';

const useVerifyEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const customerId = useSelector((state) => state.accounts.user.id);

  const verify = useCallback(async ({
    firstName, lastName, email, code,
  }, { onSuccess }) => {
    setIsLoading(true);
    setError(null);

    try {
      await Auth.verifyCurrentUserAttributeSubmit('email', code);
      await request({
        uri: 'customers/account-settings',
        options: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            customerId,
          },
          body: JSON.stringify({
            firstName,
            lastName,
            email,
          }),
        },
      });

      dispatch({ type: 'accounts/updateEmail', payload: email });
      const data = {
        listID: 'subscribe_welcome_popup',
        authData: {
          email,
        },
        channels: {
          email,
        },
      };
      window.pubSub?.publish('onEmailSubscribe', data);

      setIsLoading(false);
      onSuccess();
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  }, [customerId, dispatch]);

  return { verify, isLoading, error };
};

export default useVerifyEmail;
